import React, { createContext, useContext, useMemo } from "react";
import { useGate } from "./gate.jsx";
import { canAccessRoute, KPI_ACCESS, WORKBENCH_ACCESS, TWIN_ACCESS } from "./users";
import { useModules } from "./modules.jsx";

const RoleContext = createContext({
  role: null,
  user: null,
  canAccess: () => false,
  isHidden: () => false,
  kpiCategories: null,
  workbenchGroups: null,
  twinCategories: null,
  branchScope: null,
});

export function RoleProvider({ children }) {
  const { user } = useGate();
  const { isHidden } = useModules();

  const value = useMemo(() => {
    if (!user) {
      return {
        role: null, user: null,
        canAccess: () => false,
        isHidden,
        kpiCategories: [], workbenchGroups: [], twinCategories: [],
        branchScope: null,
      };
    }
    return {
      role: { id: user.role, name: user.roleLabel, short: user.roleShort, scope: user.scope },
      user,
      canAccess: (path) => canAccessRoute(user.role, path) && !isHidden(path),
      isHidden,
      kpiCategories: KPI_ACCESS[user.role] ?? null,    // null = all
      workbenchGroups: WORKBENCH_ACCESS[user.role] ?? null,
      twinCategories: TWIN_ACCESS[user.role] ?? null,
      branchScope: user.branchId ? { branchId: user.branchId, branchName: user.branchName } : null,
    };
  }, [user, isHidden]);

  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
}

export const useRole = () => useContext(RoleContext);
